export const apiListaMaterialesPorFechaLimiteGet = (material, fechaLimite) =>
    // eslint-disable-next-line implicit-arrow-linebreak
    fetchApi(
        `api/lista_materiales/last?material_padre=${material}&fecha_limite=${fechaLimite}`,
        {
            method: "GET",
        },
    );
